import { useCallback } from "react";

import { EventMountArg } from "@fullcalendar/common";

import { Activity } from "@mapmycustomers/shared/types/entity";

import { default as CalendarEventObject } from "../component/ActivityCalendarPage/type/EventObject";
import { default as SchedulerEventObject } from "../component/ActivitySchedulerPage/type/EventObject";

const useEventRenderer = (
  calendarCoordinates: [number, number],
  className: string,
  setActivityForContextMenu: (activity: Activity | undefined) => void,
  setContextMenuCoordinates: (coordinates: [number, number]) => void
) =>
  useCallback(
    (arg: EventMountArg) => {
      arg.el.addEventListener("contextmenu", (event: MouseEvent) => {
        event.preventDefault();
        const payload: CalendarEventObject | SchedulerEventObject = arg.event.extendedProps;
        if (payload.activity) {
          setActivityForContextMenu(payload.activity);
          let x = event.pageX - calendarCoordinates[0];
          let y = event.pageY - calendarCoordinates[1];
          const activityCalendarViews = document.getElementsByClassName(className);
          if (activityCalendarViews.length) {
            x += activityCalendarViews[0].scrollLeft;
            y += activityCalendarViews[0].scrollTop;
          }
          const menu = document.getElementsByClassName("activity-menu");
          if (menu.length) {
            const menuElement = menu[0];
            if (window.innerWidth - event.pageX < menuElement.clientWidth) {
              x -= menuElement.clientWidth;
            }
            if (window.innerHeight - event.pageY < menuElement.clientHeight) {
              y -= menuElement.clientHeight;
            }
          }
          setContextMenuCoordinates([x, y]);
        }
      });
    },
    [calendarCoordinates, className, setActivityForContextMenu, setContextMenuCoordinates]
  );
export default useEventRenderer;
